const routes = [{
  path: '/system',
  name: 'system-parameter-setting',
  component: () => import('./pages/System'),
  meta: {
    // dependApp: true,
    requireAuth: false,
    routerAlive: true
  }
}];
export default routes